import {Input, NgModule, Pipe, PipeTransform} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';
import { TextMaskModule } from 'angular2-text-mask';

import { PatientInfoComponent } from './patient-info/patient-info.component';
import { PatientRoutingModule } from './patient-routing.module';
import { PatientComponent } from './patient.component';
import { PatientAddressComponent } from './patient-address/patient-address.component';
import { PatientAppointmentSummaryComponent } from './patient-appointment-summary/patient-appointment-summary.component';
import { PatientCommsComponent } from './patient-comms/patient-comms.component';
import { PatientContactsComponent } from './patient-contacts/patient-contacts.component';
import { PatientEditComponent } from './patient-edit/patient-edit.component';
import { PatientFindComponent } from './patient-find/patient-find.component';

import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatStepperModule } from '@angular/material/stepper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PatientInsuranceCardComponent } from './patient-insurance-card/patient-insurance-card.component';
import { FormsFormModule } from '../forms/forms-form/forms-form.module';

import { A11yModule } from '@angular/cdk/a11y';
import { ValidValueSelectModule } from '../../tdo-controls/validvalueselect/validvalueselect-module';
import { PatientDoctorComponent } from './patient-doctor/patient-doctor.component';
import {DirectivesModule} from '../../directives/directives.module';
import {ConfirmModule} from '../../dialog/confirm-dialog/confirm.module';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';


@Pipe({
  name: 'dob2age'
})
export class Dob2agePatientPipe implements PipeTransform {
  transform(dob: string): number {
    const d = +new Date() - +new Date(dob);
    return d / 1000 / 60 / 60 / 24 / 365;
  }
}

@Pipe({ name: 'capitalizePipe' })
export class CapitalizePipe implements PipeTransform {
  transform(value: string, isEnabled: boolean = true): string {
    if (!isEnabled) {
      return;
    }
    if (value && value.length) {
      if (value.length > 1) {

        const finalArray = [];
        const valArray = value.split(' ');
        valArray.forEach(val => {
          if (val.length > 1) {
            finalArray.push(val.slice(0, 1).toUpperCase() + val.slice(1, val.length));
          } else {
            finalArray.push(val.toUpperCase());
          }
        });

        const finalValue = finalArray.join(' ');
        return finalValue;
      } else {
        return value.toUpperCase();
      }
    } else {
      return value;
    }
  }
}

@Pipe({
  name: 'formatPhone'
})
export class FormatPatientPhonePipe implements PipeTransform {
  transform(phoneValue: any, country?: any): any {
    try {
      if (country == null) {
        country = 'US';
      }

      const phoneNumber = parsePhoneNumber(phoneValue + '', country as CountryCode);
      return phoneNumber.formatNational();
    } catch (error) {
      return phoneValue;
    }
  }
}

@NgModule({
  declarations: [
    Dob2agePatientPipe,
    FormatPatientPhonePipe,
    CapitalizePipe,
    PatientComponent,
    PatientAddressComponent,
    PatientAppointmentSummaryComponent,
    PatientCommsComponent,
    PatientContactsComponent,
    PatientEditComponent,
    PatientFindComponent,
    PatientInfoComponent,
    PatientInsuranceCardComponent, PatientDoctorComponent,
  ],
    imports: [
        CommonModule,
        FormsModule,
        PatientRoutingModule,
        TextMaskModule,
        FormsFormModule,
        ConfirmModule,
        DirectivesModule,
        ValidValueSelectModule,

        MatTooltipModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCardModule,
        MatIconModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatGridListModule,
        MatSnackBarModule,
        MatListModule,
        MatRadioModule,
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        A11yModule,
        ReactiveFormsModule,
        // FlexLayoutModule,
        MatBottomSheetModule,
        MatButtonToggleModule,
        MatStepperModule,
        MatBadgeModule,
        MatProgressSpinnerModule,
        TdoControlsModule,

    ],
  exports: [
    PatientComponent,
    PatientAddressComponent,
    PatientAppointmentSummaryComponent,
    PatientCommsComponent,
    PatientContactsComponent,
    PatientEditComponent,
    PatientFindComponent,
    PatientInfoComponent,
    Dob2agePatientPipe,
    CapitalizePipe,
    FormatPatientPhonePipe,
  ]
})
export class PatientModule { }
